import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import Loader from "src/shared/Loader";

import { SeasonDetail } from "src/types/seasonDetail";

import { API_key, Base_URL } from "src/apiConstants";
import { dateFormat } from "src/utility";

import classes from "./EpisodesDetail.module.css";
import star from "src/assets/images/star.png";

const EpisodesDetail = () => {
  const [episodeData, setEpisodeData] = useState<SeasonDetail | null>(null);

  let { id, seasonCount } = useParams();
  console.log(seasonCount);

  let URL_Episodes = `${Base_URL}/tv/${id}/season/${seasonCount}?${API_key}&language=en-US`;

  useEffect(() => {
    axios.get(URL_Episodes).then((response) => setEpisodeData(response.data));
  }, [URL_Episodes]);

  if (!episodeData) {
    return <Loader />;
  }

  return (
    <div className={classes.episodeContainer}>
      <ul className={classes.episodesList}>
        {episodeData.episodes.map((eps) => (
          <li className={classes.epsLi}>
            <img
              className={classes.episodeImg}
              alt="show backdrop"
              src={`https://image.tmdb.org/t/p/w200${eps.still_path}`}
            />
            <section className={classes.episodeInfo}>
              <h3 className={classes.episodeHeading}>{eps.name}</h3>
              <div className={classes.littleDetails}>
                <span className={classes.seasonEpsNo}>
                  S{eps.season_number}:E{eps.episode_number}
                </span>
                <span className={classes.episodeAirDate}>
                  {dateFormat(eps.air_date)}
                </span>
                <span className={classes.episodeDuration}>
                  {eps.runtime} min
                </span>
                <div className={classes.ratingStar}>
                  <span>{Math.round(eps.vote_average)}</span>
                  <img
                    src={star}
                    alt="rating star"
                    className={classes.star}
                  ></img>
                </div>
              </div>
              <p>{eps.overview}</p>
            </section>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EpisodesDetail;
